import { Switch, Route } from "react-router-dom";
import { AppRoutes, RouterPaths } from "@ugg/shared/routes/app-routes";
import { TierList } from "@ugg/shared/components/TierList/pages/Default/TierList";
import { CombatTierListContainer } from "@ugg/shared/components/TierList/pages/Combat/CombatTierListContainer";
import { ObjectivesTierListContainer } from "@ugg/shared/components/TierList/pages/Objectives/ObjectivesTierListContainer";
import { DuoTierListContainer } from "@ugg/shared/components/TierList/pages/Duo/DuoTierListContainer";
import { ArenaTierListContainer } from "@ugg/shared/components/TierList/pages/Arena/ArenaTierListContainer";
import { ArenaDuoTierListContainer } from "@ugg/shared/components/TierList/pages/Arena/ArenaDuoTierListContainer";
import StickyNewsBanner from "components/TierList/TierListNewsBanner";

const banner = <StickyNewsBanner linkText="Read More" />;

export const TierListRoutes = () => {
  return (
    <Switch>
      <Route path={AppRoutes.ARENA_TIER_LIST} render={() => <ArenaTierListContainer bannerSlot={banner} />} />
      <Route path={AppRoutes.ARENA_DUO_TIER_LIST} render={() => <ArenaDuoTierListContainer bannerSlot={banner} />} />
      <Route path={AppRoutes.DUO_TIER_LIST} render={() => <DuoTierListContainer bannerSlot={banner} />} />
      <Route path={AppRoutes.COMBAT_TIER_LIST} render={() => <CombatTierListContainer bannerSlot={banner} />} />
      <Route path={AppRoutes.OBJECTIVES_TIER_LIST} render={() => <ObjectivesTierListContainer bannerSlot={banner} />} />
      <Route path={RouterPaths.TIER_LIST} render={() => <TierList bannerSlot={banner} />} />
    </Switch>
  );
};
